import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import FormInput from 'partial/form/FormInput';
import { showModal } from 'partial/components/Modal';
import { ImSpinner8 } from 'react-icons/im';
import Button from 'partial/components/Button';
import { req } from 'react-reqq-lite';

export const showToggleAuthOtp = (onToggleSuccess) => {
  showModal({
    size: 'sm',
    title: 'Manage One-Time-Pin',
    content: (onClose) => (
      <OtpModal
        onSubmit={(payload, onSuccess, onError) => {
          req.put({
            key: 'TOGGLE_AUTH_OTP',
            url: '/api/admin/profile/toggle_2fa_confirm_otp',
            payload: {
              code: payload.pin,
            },
            onSuccess: () => {
              onSuccess();
              if (onToggleSuccess) onToggleSuccess();
            },
            onError,
          });
        }}
        onSendOtp={(onSuccess, onError) => {
          req.post({
            key: 'TOGGLE_AUTH_OTP',
            url: '/api/admin/profile/toggle_2fa_send_otp',
            onSuccess: () => {
              onSuccess(undefined);
            },
            onError: () => {
              onError();
            },
          });
        }}
        onClose={onClose}
      />
    ),
  });
};

export const showAuthOtpModal = (payload, onAuthSuccess) => {
  showModal({
    size: 'sm',
    title: 'One-Time-Pin',
    content: (onClose) => (
      <OtpModal
        sendOnMount
        onSubmit={({ pin }, onSuccess, onError) => {
          req.post({
            key: 'AUTH_OTP',
            url: '/api/v1/auth/login/administrator/confirm-otp',
            payload: { ...payload, code: pin, sent_via: "email" },
            onSuccess: (res) => {
              onSuccess();
              onAuthSuccess(res);
            },
            onError: () => {
              onError();
            },
          });
        }}
        onSendOtp={(onSuccess) => {
          setTimeout(() => {
            onSuccess(undefined);
          }, 1000);
        }}
        onClose={onClose}
      />
    ),
  });
};

function OtpModal({ onSubmit, onClose, sendOnMount, onSendOtp }) {
  const [isSending, setIsSending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isOtpSent, setIsOtpSent] = useState(sendOnMount);
  const [label, setLabel] = useState(
    'A 6-digit pin has been sent to your mobile number'
  );
  useEffect(() => {
    if (sendOnMount) {
      setIsSending(true);
      onSendOtp(
        (recipent_number) => {
          setLabel(
            `A 6-digit pin has been sent to your ${
              recipent_number ? `number(${recipent_number})` : 'mobile number'
            }`
          );
          setIsOtpSent(true);
          setIsSending(false);
        },
        () => {
          setIsOtpSent(false);
          setIsSending(false);
        }
      );
    }
    // eslint-disable-next-line
  }, [sendOnMount]);

  const [form, setForm] = React.useState({ pin: '' });
  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    onSubmit(
      form,
      () => {
        // on SUCCESS
        onClose();
      },
      () => {
        // on ERROR
        setForm({ pin: '' });
        setIsLoading(false);
      }
    );
  };
  if (isSending)
    return (
      <div className="p-3 text-center">
        <div className="flex flex-col justify-center items-center space-y-4">
          <ImSpinner8 className="animate-spin text-3xl" />
          <div>Sending One-Time-Pin...</div>
        </div>
      </div>
    );
  if (!isOtpSent) {
    return (
      <div className="p-3">
        <div className="mb-4">
          One-Time-PIN is required to proceed. Send OTP?
        </div>
        <div className="flex justify-center space-x-1">
          <Button
            primary
            onClick={() => {
              setIsSending(true);
              onSendOtp(
                (recipent_number) => {
                  setLabel(
                    `A 6-digit pin has been sent to your ${
                      recipent_number
                        ? `number(${recipent_number})`
                        : 'mobile number'
                    }`
                  );
                  setIsOtpSent(true);
                  setIsSending(false);
                },
                () => {
                  setIsOtpSent(false);
                  setIsSending(false);
                }
              );
            }}
            disabled={isSending}
          >
            Send OTP
          </Button>
          <Button onClick={() => onClose()}>Cancel</Button>
        </div>
      </div>
    );
  }
  return (
    <>
      <form className="p-3" onSubmit={handleSubmit}>
        <div className="mb-2">
          <FormInput
            name="pin"
            onChange={setForm}
            value={form.pin}
            label={label}
            required
          />
        </div>
        <div className="flex justify-center space-x-1">
          <Button primary type="submit" disabled={isLoading}>
            Continue
          </Button>
          <Button onClick={() => onClose()}>Cancel</Button>
        </div>
      </form>
    </>
  );
}

OtpModal.defaultProps = {
  sendOnMount: false,
};

OtpModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  sendOnMount: PropTypes.bool,
  onSendOtp: PropTypes.func.isRequired,
};

export default OtpModal;
